import { render, staticRenderFns } from "./eventDetails.modal.vue?vue&type=template&id=5151e2b2&scoped=true&"
import script from "./eventDetails.modal.vue?vue&type=script&lang=js&"
export * from "./eventDetails.modal.vue?vue&type=script&lang=js&"
import style0 from "./eventDetails.modal.vue?vue&type=style&index=0&id=5151e2b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5151e2b2",
  null
  
)

export default component.exports